import TextArea from "@/components/TextArea/TextArea";
import { useFormContext, type FieldValues } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import { errorMessageAt, withPrefix } from "@/forms/fieldPath";

export type IDescriptionInputFields = {
  description: string;
};

export const DescriptionInput = ({
  showHelperText = true,
  namePrefix,
}: {
  showHelperText?: boolean;
  namePrefix?: string;
}) => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const descriptionPath = withPrefix(namePrefix, "description");
  const errorMessage = errorMessageAt(errors, descriptionPath);

  return (
    <TextArea
      label={t`Beskrivning`}
      showOptionalLabel
      description={showHelperText ? t`Visas inte för patienten` : undefined}
      errorMessage={errorMessage}
      {...register(descriptionPath)}
    />
  );
};
